import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import Jobfrom from '../MenCareer/Careerfrom'
import Footer from '../Footer/Main'

function Main() {
  return (
    <>
    <div className="page-wrapper">
        <Header />
        <Breadcrumb subtitle="Home" title="Careers" />
        <Jobfrom />
        <Footer />
    </div>
    </>
  )
}

export default Main